import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BottomSidebarComponent} from "./bottom-sidebar/bottom-sidebar.component";
import {SidebarModule as PrimeNgSidebarModule} from "primeng/sidebar";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";


@NgModule({
  declarations: [BottomSidebarComponent],
  imports: [
    CommonModule,
    PrimeNgSidebarModule,
    ButtonModule,
    RippleModule
  ],
  exports: [BottomSidebarComponent]
})
export class SidebarModule { }
